var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFizzSad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 220",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .root { transform-origin: 100px 110px; transform-box: fill-box; }\n  \n        .root { animation: droop 5.5s ease-in-out infinite; }\n        @keyframes droop {\n          0%, 100% { transform: translateY(2px) rotate(-1deg); }\n          50% { transform: translateY(4px) rotate(-1.8deg); }\n        } \n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sharkBody",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9ec4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5a8aa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2f5a78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sharkBelly",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f4f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#cdddea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sharkFin",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7aa3bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#244e6a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bubg",
    cx: "35%",
    cy: "30%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#cfeefb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168,128 Q188,98 196,82 Q200,108 196,128 Q200,148 196,170 Q188,156 168,140 Z",
    fill: "url(#sharkFin)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86,82 Q104,46 124,80 Q110,86 96,86 Z",
    fill: "url(#sharkFin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,162 Q148,178 156,160 Q150,156 142,156 Z",
    fill: "url(#sharkFin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "           M40,128           Q40,90 80,78           Q120,72 158,86           Q176,108 168,132           Q172,156 156,168           Q120,180 78,176           Q44,168 40,128 Z",
    fill: "url(#sharkBody)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "           M48,140           Q60,170 100,176           Q146,178 168,148           Q160,168 130,176           Q92,182 60,170           Q50,160 48,140 Z",
    fill: "url(#sharkBelly)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "pec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76,148 Q56,158 60,176 Q86,170 92,156 Z",
    fill: "url(#sharkFin)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62,124 Q60,130 62,136",
    stroke: "#2a1a1a",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,122 Q66,130 68,138",
    stroke: "#2a1a1a",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,122 Q72,130 74,138",
    stroke: "#2a1a1a",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 98,
    rx: 22,
    ry: 5,
    fill: "white",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 108,
    rx: 3.5,
    ry: 1.6,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 124,
    rx: 5,
    ry: 2.6,
    fill: "#ff7e9c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115,
    cy: 124,
    rx: 5,
    ry: 2.6,
    fill: "#ff7e9c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89,
    cy: 118,
    rx: 2.8,
    ry: 1.9599999999999997,
    fill: "#2a1a1a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111,
    cy: 118,
    rx: 2.8,
    ry: 1.9599999999999997,
    fill: "#2a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,115 Q88,113.8 91,114.8",
    stroke: "#2a1a1a",
    strokeWidth: 1.3,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,114.8 Q112,113.8 114.5,115",
    stroke: "#2a1a1a",
    strokeWidth: 1.3,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,131 Q100,127.5 105,131",
    stroke: "#2a1a1a",
    strokeWidth: 1.6,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,122 Q83,126 80,130 Q77,126 80,122 Z",
    fill: "#7ec8f0",
    stroke: "#1a1a1a",
    strokeWidth: 0.8,
    opacity: 0.95
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFizzSad);
export default __webpack_public_path__ + "static/media/fizz-sad.847cebd3dcc493dc9bf3f9838ed642d8.svg";
export { ForwardRef as ReactComponent };